import { opinions } from '../defaults/opinions';

export const dinkelAuflauf = {
	name: 'Veganer Broccoli-Dinkel Auflauf',
	desc: 'vegane Paprikasauce, bunter Krautsalat mit Paprika und Tagesdessert Clementine.',
	image: 8,
	benefits: [
		'Besonders verträglich',
		'Reguliert die Verdauung',
		'Kalorienarm',
	],
	opinions: [
		{
			name: 'Jane Doe',
			date: '14. Januar 2017',
			title: 'Muss nachgesalzen werden',
			content: 'Sehr lecker wenn man sich noch etwas Salz und Pfeffer mitnimmt',
			rating: 4,
		},
		...opinions,
	],
	warnings: ['gluten', 'soja'],
	ingredients: [
		{'Dinkel': 'gluten'},
		'Zwiebeln',
		'Brokkoli',
		'Paprika',
		'Karotten',
		'Kohlrabi',
		'Margarine',
		{'Mehl': 'gluten'},
		{'Sojamilch': 'soja'},
		'Salz',
		'Muskat',
		{'Hefeschmelz': 'hefe'},
	]
};



// WEBPACK FOOTER //
// ./src/dishes/single-dishes/dinkelAuflauf.js